export default __webpack_public_path__ + "static/qacase2-68156c46ab614da67f0f5c9645f13c5c.png";